<template>
  <div class="container">
    <loading v-bind:active.sync="loading"></loading>
    <auth-modal ref="authModal"></auth-modal>
    <div class="row top-padding">
      <div class="col-lg-3 offset-lg-2">
        <label for="companyId">Company Code<span class="red">*</span></label>
      </div>
      <div class="col-lg-5">
        <input type="text" v-model="companyId" class="form-control">
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 offset-lg-2">
        <label for="companyName">Company Name<span class="red">*</span></label>
      </div>
      <div class="col-lg-5">
        <input type="text" v-model="companyName" class="form-control">
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 offset-lg-2">
        <label for="address">Address<span class="red">*</span></label>
      </div>
      <div class="col-lg-5">
        <input type="text" v-model="address" v-on:input="onAddressInput" class="form-control">
        <ul v-if="suggestions.length" class="suggestions">
          <li v-for="prediction in suggestions" v-on:click="selectAddress(prediction)" v-bind:key="prediction.place_id">{{ prediction.description }}</li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 offset-lg-2">
        <label for="details">Services Provided<span class="red">*</span></label>
      </div>
      <div class="col-lg-5">
        <input type="text" v-model="details" class="form-control">
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 offset-lg-2">
        <label for="callNumber">Customer Contact Phone Number<span class="red">*</span></label>
      </div>
      <div class="col-lg-5">
        <input type="text" v-model="callNumber" class="form-control">
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 offset-lg-2">
        <label for="email">Customer Contact Email<span class="red">*</span></label>
      </div>
      <div class="col-lg-5">
        <input type="text" v-model="email" class="form-control">
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 offset-lg-2">
        <label for="profilePicture">Company Logo</label><span class="red">*</span>
      </div>
      <div class="col-lg-5 fix-custom-label">
        <label class="custom-file-label" for="customFile">Upload file</label>
        <input class="custom-file-input" id="customFile" type="file" accept="image/png, image/jpeg" v-on:change="previewImage">
        <img class="preview-image" v-bind:src="profilePicture" v-on:click="updateLogo(null)" height="100px">
      </div>
    </div>
    <div class="row">
      <div class="col-4 offset-4">
        <button class="btn btn-primary" v-on:click="createServiceProvider()">Register</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Chrome } from 'vue-color'
import AuthModal from '../authentication/TheAuthModal.vue'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import router from '../../router/index.js'

export default {
  components: {
    AuthModal,
    'color-picker': Chrome,
    Loading
  },
  data () {
    return {
      backgroundColors: {
        hex: '#000000'
      },
      code: null,
      displayBackgroundColorPicker: false,
      displayTextColorPicker: false,
      textColors: {
        hex: '#000000'
      },
      loading: false,
      autocompleteService: null,
      geocoder: null,
      debounceTimer: null,
      suggestions: []
    }
  },
  mounted () {
    this.autocompleteService = new window.google.maps.places.AutocompleteService()
    this.geocoder = new window.google.maps.Geocoder()
  },
  methods: {
    ...mapActions('business', [
      'getUserAttributes'
    ]),
    ...mapActions('serviceProvider', [
      'putServiceProviderData'
    ]),
    ...mapMutations('serviceProvider', [
      'updateAddress',
      'updateCallNumber',
      'updateDetails',
      'updateEmail',
      'updateLogo',
      'updateCompanyId',
      'updateCompanyName',
      'updateOwnerId',
      'updateLatitude',
      'updateLongitude'
    ]),
    // Debounced input handler
    onAddressInput () {
      clearTimeout(this.debounceTimer)
      if (!this.address) {
        this.suggestions = []
        return
      }

      this.debounceTimer = setTimeout(() => {
        this.getPredictions(this.address).then(predictions => {
          this.suggestions = predictions
        }).catch(error => {
          console.error("Autocomplete error:", error)
        })
      }, 300)
    },
    // Promise wrapper for Autcomplete
    getPredictions (input) {
      return new Promise((resolve, reject) => {
        this.autocompleteService.getPlacePredictions(
          { input: input, types: ["address"], componentRestrictions: { country: "us"} },
          (predictions, status) => {
            if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
              return reject(status)
            }
            resolve(predictions)
          }
        )
      })
    },
    // Promise wrapper for Geocoder
    geocodeByPlaceId(placeId) {
      return new Promise((resolve, reject) => {
        this.geocoder.geocode({ placeId: placeId }, (results, status) => {
          if (status != window.google.maps.GeocoderStatus.OK) {
            return reject(status)
          }
          resolve(results[0])
        })
      })
    },
    // When user selects suggestions
    selectAddress(prediction) {
      this.address = prediction.description
      this.suggestions = []
      this.geocodeByPlaceId(prediction.place_id).then(result => {
        const location = result.geometry.location
        this.latitude = location.lat().toString()
        this.longitude = location.lng().toString()
      }).catch(error => {
        console.error("Geocode error", error)
      })
    },
    previewImage: function (event) {
      var input = event.target
      var that = this
      if (input.files && input.files[0]) {
        var reader = new FileReader()
        reader.onload = function (e) {
          if (!that.profilePicture || (that.profilePicture && !that.profilePicture.includes(e.target.result))) {
            var img = new Image()
            img.onload = function () {
              if (this.width > 150 && this.height > 150) {
                that.updateLogo(e.target.result)
              } else {
                that.imageTooSmall = true
              }
            }
          }
          img.src = e.target.result
        }
        reader.readAsDataURL(input.files[0])
      }

      var fileInput = document.getElementById('customFile')
      fileInput.value = null
    },
    async createServiceProvider () {
      if (!this.getIdProvider) {
        this.$refs.authModal.$refs.authModal.show()
        return
      }
      this.loading = true
      try {
        this.updateOwnerId(this.getCognitoId)
        await this.putServiceProviderData({ companyId: this.companyId, method: 'POST' })
        this.getUserAttributes()
        router.push('/profile/serviceprovider/dashboard')
      } catch (error) {
        console.log(error)
      }
      this.loading = false
    }
  },
  computed: {
    ...mapGetters([
      'getCognitoId',
      'getIdProvider'
    ]),
    ...mapGetters('serviceProvider', [
      'getAddress',
      'getCallNumber',
      'getDetails',
      'getEmail',
      'getLogo',
      'getCompanyId',
      'getCompanyName',
      'getLatitude',
      'getLongitude'
    ]),
    address: {
      get () {
        return this.getAddress
      },
      set (value) {
        this.updateAddress(value)
      }
    },
    callNumber: {
      get () {
        return this.getCallNumber
      },
      set (value) {
        this.updateCallNumber(value)
      }
    },
    details: {
      get () {
        return this.getDetails
      },
      set (value) {
        this.updateDetails(value)
      }
    },
    email: {
      get () {
        return this.getEmail
      },
      set (value) {
        this.updateEmail(value)
      }
    },
    companyId: {
      get () {
        return this.getCompanyId
      },
      set (value) {
        this.updateCompanyId(value)
      }
    },
    companyName: {
      get () {
        return this.getCompanyName
      },
      set (value) {
        this.updateCompanyName(value)
      }
    },
    latitude: {
      get () {
        return this.getLatitude
      },
      set (value) {
        this.updateLatitude(value)
      }
    },
    longitude: {
      get () {
        return this.getLongitude
      },
      set (value) {
        this.updateLongitude(value)
      }
    },
    profilePicture: {
      get () {
        return this.getLogo
      },
      set (value) {
        this.updateLogo(value)
      }
    }
  }
}
</script>

<style scoped>
.custom-file-input {
  line-height: 1.25;
}

.custom-file-label {
  line-height: 1.25;
}

@media (min-width: 992px) {
  .custom-file-label {
    width: 368px;
  }
}

@media (min-width: 1200px) {
  .custom-file-label {
    width: 443px;
  }
}

@media (min-width: 1500px) {
  .custom-file-label {
    width: 551.328px;
  }
}

.custom-file-label::after {
  line-height: 1.25;
}

.fix-custom-label {
  padding: 0;
  margin: 0 15px;
}

.row {
  margin-bottom: 1.5rem;
}

.color-picker {
  position: absolute;
  top: 39px;
  right: 15px;
  z-index: 3;
}

.current-color {
  display: inline-block;
  width: 16px;
  height: 16px;
}

label {
  font-size: 1.25rem;
  margin: 0;
}

.top-padding {
  padding-top: 3rem;
}

.pointer-cursor {
  cursor: pointer;
}

.red {
  color: red !important;
}

.suggestions {
  list-style: none;
  padding: 0;
  margin: 0;
  border: 1px solid #ccc;
  max-width: 300px;
  background: white;
  position: absolute;
  z-index: 1000;
}

.suggestions li {
  padding: 8px;
  cursor: pointer;
}

.suggestions li:hover {
  background: #f0f0f0;
}
</style>



// WEBPACK FOOTER //
// src/components/serviceprovider/ServiceProviderSignUp.vue